interface CacheItem<T> {
  data: T;
  timestamp: number;
  ttl: number;
}

export class CacheManager {
  private memoryCache = new Map<string, CacheItem<unknown>>();

  get<T>(key: string): T | null {
    const item = this.memoryCache.get(key);
    if (!item) return null;

    if (Date.now() - item.timestamp >= item.ttl) {
      this.memoryCache.delete(key);
      return null;
    }

    return item.data as T;
  }

  set<T>(key: string, data: T, ttl: number): void {
    this.memoryCache.set(key, {
      data,
      timestamp: Date.now(),
      ttl,
    });
  }

  delete(key: string): void {
    this.memoryCache.delete(key);
  }

  getAllKeys(): string[] {
    return Array.from(this.memoryCache.keys());
  }

  clear(): void {
    this.memoryCache.clear();
  }
}
